/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `color` - color
 * * `enum` - enum
 * * `toggle` - toggle
 */
export type AvatarControlKindEnum = typeof AvatarControlKindEnum[keyof typeof AvatarControlKindEnum];


export const AvatarControlKindEnum = {
  color: 'color',
  enum: 'enum',
  toggle: 'toggle',
} as const;
